import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/252619150114";

export default function WhatsAppFAB() {
  const [showBubble, setShowBubble] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => setShowBubble(true), 4000);
    const hideTimer = setTimeout(() => setShowBubble(false), 12000);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  const closeBubble = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowBubble(false);
    setDismissed(true);
  };

  return (
    <div className="fixed right-6 bottom-6 z-50 flex flex-col items-end gap-3">
      {/* Greeting bubble */}
      <AnimatePresence>
        {showBubble && !dismissed && (
          <motion.div
            initial={{ opacity: 0, x: 20, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 20, scale: 0.9 }}
            transition={{ type: "spring", stiffness: 400, damping: 25 }}
            className="relative max-w-[200px] rounded-2xl rounded-br-sm bg-card px-4 py-3 shadow-lg shadow-black/10 border border-border"
          >
            <button
              onClick={closeBubble}
              className="absolute -top-2 -left-2 flex h-5 w-5 items-center justify-center rounded-full bg-muted-bg text-muted hover:bg-gray-300 transition-colors"
              aria-label="Dismiss"
            >
              <X className="h-3 w-3" />
            </button>
            <p className="text-[11px] font-medium text-navy leading-relaxed">
              👋 Caawimaad ma u baahan tahay? WhatsApp nagala soo xiriir!
            </p>
          </motion.div>
        )}
      </AnimatePresence>

      {/* FAB button */}
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 300, damping: 20, delay: 1 }}
      >
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          className="group relative flex items-center gap-2 rounded-full bg-[#25D366] text-white transition-all duration-300 ease-out hover:shadow-xl hover:shadow-green-500/30"
          style={{
            padding: hovered ? "16px 24px 16px 18px" : "16px",
          }}
        >
          {/* Pulse rings — hidden on mobile to prevent GPU rendering glitches */}
          <span
            className="absolute inset-0 rounded-full animate-ping bg-[#25D366]/25 pointer-events-none hidden sm:block"
            style={{ animationDuration: "2.5s" }}
          />
          <span
            className="absolute inset-0 rounded-full bg-[#25D366]/15 animate-pulse pointer-events-none hidden sm:block"
            style={{ animationDuration: "2s" }}
          />

          {/* WhatsApp icon */}
          <motion.div
            animate={{ rotate: hovered ? [0, -10, 10, -5, 0] : 0 }}
            transition={{ duration: 0.5 }}
            className="relative z-10"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" className="h-8 w-8">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
          </motion.div>

          {/* Expanding label */}
          <AnimatePresence>
            {hovered && (
              <motion.span
                initial={{ width: 0, opacity: 0 }}
                animate={{ width: "auto", opacity: 1 }}
                exit={{ width: 0, opacity: 0 }}
                transition={{ duration: 0.2 }}
                className="relative z-10 overflow-hidden whitespace-nowrap text-base font-semibold"
              >
                Nala Soo Xiriir
              </motion.span>
            )}
          </AnimatePresence>
        </a>
      </motion.div>
    </div>
  );
}
